import React, { useMemo } from 'react';
import { Box, Chip, LinearProgress } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import { Account } from '../../../../../stores/AccountStore';
import AccountImportStore from '../store/AccountImportStore';
import { isEmpty } from '../../../../utils/isEmpty';
import { useAuth } from '../../../../../hooks/useAuth';

type Props = {
    account: Account;
};

const ValidationColumn = ({ account }: Props) => {
    const [loading, setLoading] = React.useState(true);
    const [success, setSuccess] = React.useState(false);
    const { user } = useAuth();

    React.useEffect(() => {
        validateLead();
    }, [account]);

    if (!user) return null;

    const fieldsToCheck = ['name'];

    const validateLead = async () => {
        let hasError = false;
        let needsUpdate = false;
        const tempLead = structuredClone(account);

        //var fieldsToCheck = ['firstName', 'lastName', 'emailAddress', 'company', 'jobTitle', 'linkedIn', 'leadLevelId', 'switchboard', 'phone',
        //    'phone', 'mobile', 'city', 'province', 'countryId', 'leadSourceId', 'leadFunctionId', 'industryId', 'addressRegionId', 'leadOwnerId']

        fieldsToCheck.forEach((field) => {
            const errorField = field + 'Error';

            if (isEmpty(tempLead[field])) {
                needsUpdate = needsUpdate || !tempLead[errorField] || tempLead[errorField] === undefined;

                tempLead[errorField] = true;
                hasError = true;
            } else if (tempLead[errorField]) {
                tempLead[errorField] = false;
                needsUpdate = true;
            }
        });

        if (!tempLead.isValid || tempLead.isValid != !hasError) {
            needsUpdate = true;
        }

        tempLead.isValid = !hasError;

        if (needsUpdate) {
            AccountImportStore.update((s, o) => {
                const leadIndex = o.accounts.findIndex((s) => s.id === tempLead.id);

                if (leadIndex > -1) {
                    s.accounts[leadIndex] = tempLead;
                }
            });
        }

        setSuccess(!hasError);
        setLoading(false);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ width: '100%', mr: 1 }}>
                    {loading && <LinearProgress color="success" />}
                    {!loading && success && (
                        <Chip sx={{ width: '100%' }} icon={<DoneIcon />} color="success" size="small" />
                    )}
                    {!loading && !success && (
                        <Chip sx={{ width: '100%' }} icon={<ErrorIcon />} color="error" size="small" />
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export { ValidationColumn };
export default ValidationColumn;
